import HttpFactory from 'http-service-v3'

export default function customerSupportFactory() {
  const http = HttpFactory()
  return {
    async getSupportDoc(supportDocId) {
      return http.get(http.wsaDomain + `/supportdocs/v1/get/${supportDocId}`).then(response => {
        const { data } = response
        return data
      })
    },
    async getAllSupportDocs() {
      return http.get(http.wsaDomain + `/supportdocs/v1/getall`).then(response => {
        const { data } = response
        return data
      })
    },
    async getSearchResults(query) {
      return http.get(http.wsaDomain + `/supportdocs/v1/search/${query}`).then(response => {
        const { data } = response
        return data
      })
    },
  }
}
